import { LoggerInterface } from '../../interfaces/components/logger/logger.interface';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class Logger implements LoggerInterface {
  private enabled = true;

  debug (...args: unknown[]): void {
    this.log(args, 'debug');
  }

  info (...args: unknown[]): void {
    this.log(args, 'info');
  }

  warn (...args: unknown[]): void {
    this.log(args, 'warn');
  }

  error (...args: unknown[]): void {
    this.log(args, 'error');
  }

  log (args: unknown[], severity: 'debug' | 'info' | 'warn' | 'error'): void {
    if (!this.enabled) {
      return;
    }

    // eslint-disable-next-line no-console
    console[ severity ](`[${severity}]`, ...args);
  }

  setEnabled (enabled: boolean): void {
    this.enabled = enabled;
  }
}
